/**
 * SGKC030A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DiscountextraRateDto {

    /**
     * 割引割増契約名
     */
    discountextraCtrAname?: string;
    /**
     * 割引割増率
     */
    discountextraRate?: number;
}

